import { createStore, applyMiddleware, compose } from "redux";
import { createBrowserHistory } from "history";
import thunk from "redux-thunk";
import { routerMiddleware, connectRouter } from "connected-react-router";
import createSagaMiddleware from "redux-saga";
import createReducer from "./reducers";
import { createLogger } from "redux-logger";

import setupMiddleware from "utils/setupMiddleware";

const sagaMiddleware = createSagaMiddleware();

const userTiming = () => (next) => (action) => {
  if (performance.mark === undefined) return next(action);
  performance.mark(`${action.type}_start`);
  const result = next(action);
  performance.mark(`${action.type}_end`);
  performance.measure(`${action.type}`, `${action.type}_start`, `${action.type}_end`);
  return result;
};

export const history = createBrowserHistory();

export default function configureStore(initialState = {}) {
  const middlewares = [routerMiddleware(history), thunk, userTiming];

  const logger = createLogger({
    collapsed: true
  });

  const enhancers = [applyMiddleware(...middlewares, logger)];

  // If Redux DevTools Extension is installed use it, otherwise use Redux compose
  /* eslint-disable no-underscore-dangle */
  const composeEnhancers =
    process.env.NODE_ENV !== "production" && typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          // TODO Try to remove when `react-router-redux` is out of beta, LOCATION_CHANGE should not be fired more than once after hot reloading
          // Prevent recomputing reducers for `replaceReducer`
          shouldHotReload: false
        })
      : compose;
  /* eslint-enable */

  const store = createStore(createReducer(history), initialState, compose(...enhancers));

  // Extensions
  store.runSaga = sagaMiddleware.run;
  store.injectedReducers = {}; // Reducer registry
  store.injectedSagas = {}; // Saga registry

  // Make reducers hot reloadable, see http://mxs.is/googmo
  /* istanbul ignore next */
  if (module.hot) {
    module.hot.accept("./reducers", () => {
      store.replaceReducer(createReducer(history));
      store.dispatch({ type: "@@REDUCER_INJECTED" });
    });
  }

  return store;
}
